import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";

export default function About() {
  const { t, link } = useLang();
  const principles = t("about.principles");
  return (
    <>
      <Seo page="about" />
      <section className="bg-ink bg-grid-dark pt-[140px] pb-16 lg:pt-[180px] lg:pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <p className="text-xs font-semibold tracking-[0.25em] text-electric">{t("about.eyebrow")}</p>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight max-w-3xl">{t("about.title")}</h1>
            <p className="mt-6 max-w-2xl text-base sm:text-lg text-steel leading-relaxed">{t("about.copy")}</p>
            <p className="mt-4 max-w-2xl text-base text-steel leading-relaxed">{t("about.copy2")}</p>
            <div className="mt-12 max-w-4xl overflow-hidden rounded-2xl border border-white/10">
              <img src="/images/dashboard.jpg" alt="Digital technology visual" loading="lazy" className="w-full object-cover max-h-[440px]" width="1600" height="1067" />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-mist text-ink py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {principles.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.06}>
                <div className="h-full rounded-2xl border border-ink/10 bg-white p-7">
                  <p className="font-display text-sm font-extrabold tracking-wide text-dblue">{p.title}</p>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{p.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-ink2 bg-grid-dark py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Reveal>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">{t("about.workTitle")}</h2>
            <p className="mt-4 text-base text-steel max-w-xl mx-auto">{t("about.workCopy")}</p>
            <Link
              to={link("/projects")}
              data-testid="about-work-cta"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-dblue to-electric px-7 py-3.5 text-sm font-semibold transition-transform duration-200 hover:scale-[1.04]"
            >
              {t("about.workCta")} <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
